export async function sendEmail(sendTo, name, template) {
    const url = 'https://mailer.echeide.com/service/send/';
    const sendToEmail = [sendTo, 'cultura@losrealejos.es'];
    // const url = 'http://localhost:8700/send/'
    // const sendToEmail =  [sendTo, 'admin@echeide.com'];
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            templateName: 'El-Genio-de-los-realejos-fin-de-juego',
            to: sendToEmail,
            data: {
                playerName: name,
                code: Math.round(Math.random() * 999999)
            }
        })
    });
    if (!response.ok) {
        throw new Error('Ha ocurrido un error al obtener milestones.');
    }
}
